/**
 * Helpers per YouTube: estrazione id + URL embed da svariati formati.
 * Estratto da HeroCarousel per riuso in Evento media manager e pagine dettaglio.
 */

export function youtubeIdOf(url: string): string | null {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.slice(1).split(/[?&#]/)[0] || null;
    if (u.hostname.includes("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) return v;
      const m = u.pathname.match(/\/(embed|shorts)\/([A-Za-z0-9_-]+)/);
      if (m) return m[2];
    }
  } catch {
    /* malformed url */
  }
  return null;
}

/**
 * BP-FIX (Lighthouse "Utilizza cookie di terze parti" + "Errori Issues panel"):
 *   www.youtube.com/embed setta 4 cookie di tracking (__Secure-YNID, YSC,
 *   VISITOR_INFO1_LIVE, __Secure-ROLLOUT_TOKEN) anche prima del play.
 *   www.youtube-nocookie.com/embed e' il dominio "Privacy Enhanced Mode"
 *   ufficiale di YouTube: NON setta cookie finche' l'utente clicca play
 *   (e anche dopo, ne setta molti meno).
 *
 *   Best practice: usare youtube-nocookie per TUTTI gli iframe runtime.
 *   I link di share/SEO/sitemap restano sui domini canonici (www.youtube.com)
 *   perche' schema.org e i social previewer si aspettano l'URL ufficiale.
 *
 *   Branch "pathname.startsWith('/embed/')": preserva l'URL originale se gia'
 *   formato embed. Per uniformare, ri-mappiamo anche quel caso al dominio
 *   nocookie estraendo l'id.
 */
export function toYouTubeEmbed(url: string): string | null {
  try {
    const id = youtubeIdOf(url);
    return id ? `https://www.youtube-nocookie.com/embed/${id}` : null;
  } catch {
    return null;
  }
}

export function youtubeThumbnail(url: string, quality: "default" | "mq" | "hq" | "sd" | "maxres" = "mq"): string | null {
  const id = youtubeIdOf(url);
  if (!id) return null;
  const map: Record<string, string> = {
    default: "default",
    mq: "mqdefault",
    hq: "hqdefault",
    sd: "sddefault",
    maxres: "maxresdefault",
  };
  return `https://img.youtube.com/vi/${id}/${map[quality]}.jpg`;
}

